var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMirror(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_6259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 15L6 1V15H0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 15H6V1L0 15ZM5 5.87192V14H1.51654L5 5.87192Z",
    fill: "#626262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 15L10 1V15H16Z",
    fill: "#626262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 0V16H7.5V0H8.5Z",
    fill: "#626262"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_6259"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMirror);
export default __webpack_public_path__ + "static/media/mirror.3317efbc80617477e689f13fd5f6c2e2.svg";
export { ForwardRef as ReactComponent };